export const iconFontAwesomeGendersMarsDouble = (
	<i className="fa-solid fa-mars-double"></i>
);
